(() => {
  function init() {
    document.querySelectorAll('[data-owner-logs]').forEach(logs => {
      if (logs.dataset.logsReady) return;
      logs.dataset.logsReady = 'true';
      const tabs = [...logs.querySelectorAll('[data-log-tab]')];
      const panels = [...logs.querySelectorAll('[data-log-panel]')];
      function reveal(panel, expanded) {
        const later = panel.querySelector('[data-log-later]');
        const button = panel.querySelector('[data-log-reveal]');
        later.classList.toggle('is-revealed', expanded);
        later.setAttribute('aria-hidden', String(!expanded));
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Back to day 1' : 'Show day 21';
      }
      tabs.forEach(tab => tab.addEventListener('click', () => {
        tabs.forEach(other => other.setAttribute('aria-pressed', String(other === tab)));
        panels.forEach(panel => {
          panel.hidden = panel.dataset.logPanel !== tab.dataset.logTab;
          reveal(panel, false);
        });
      }));
      panels.forEach(panel => {
        reveal(panel, false);
        panel.querySelector('[data-log-reveal]').addEventListener('click', () => {
          reveal(panel, panel.querySelector('[data-log-reveal]').getAttribute('aria-expanded') !== 'true');
        });
      });
    });
    document.querySelectorAll('[data-kit-math]').forEach(math => {
      if (math.dataset.mathReady) return;
      const root = math.closest('[data-calm-lp]');
      const node = root?.querySelector('[data-avp-product]');
      if (!node) return;
      let catalog;
      try { catalog = JSON.parse(node.textContent); } catch (_) { return; }
      math.dataset.mathReady = 'true';
      const money = new Intl.NumberFormat('en-US', { style:'currency', currency:catalog.currency || 'USD' });
      const slider = math.querySelector('[data-math-slider]');
      const alternative = math.querySelector('[data-math-alternative]');
      const set = (selector, text) => { math.querySelector(selector).textContent = text; };
      function update() {
        const selected = root.querySelector('[data-pack-option]:checked');
        const variant = catalog.variants.find(item => String(item.id) === selected?.value);
        if (!variant) return;
        const subscribed = !!root.querySelector('[data-purchase-toggle]:checked') && !!variant.planId;
        const price = (subscribed ? variant.subscriptionPrice : variant.price) / 100;
        const daily = price / variant.count / 30;
        set('[data-math-selection]', variant.count + ' room' + (variant.count > 1 ? 's' : '') + ' · 30 days · ' + (subscribed ? 'Subscribe & Save' : 'One-time purchase'));
        set('[data-math-daily]', money.format(daily) + ' / day');
        set('[data-math-total]', money.format(price));
        set('[data-math-budget]', money.format(Number(slider.value)));
        set('[data-math-equivalent]', daily > 0 ? Math.floor(Number(slider.value) / daily).toLocaleString('en-US') : '—');
        set('[data-math-currency]', catalog.currency || 'USD');
        const alt = alternative.valueAsNumber;
        set('[data-math-alt-daily]', alternative.value !== '' && alternative.validity.valid && Number.isFinite(alt) ? money.format(alt / 30) + ' / day' : '— / day');
      }
      root.addEventListener('change', update);
      slider.addEventListener('input', update);
      alternative.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
